import { RenderTextInput } from "app/common/renderInput";
import React from "react";

export default function PriceDetails({
  values,
  setFieldValue,
  setState,
  errors,
  handleChange,
  handleBlur,
  touched,
}) {
  return (
    <div>
      <div className="row">
        <div className="col-md-3 mb-3">
          <label style={{ fontWeight: "bold" }} className="mb-1">
            Total Base Fare
          </label>

          <RenderTextInput
            type="number"
            name={`price.BF`}
            placeholder="Base Fare"
            value={values?.price?.BF}
            error={errors?.price?.BF}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched?.price?.BF}
          />
        </div>
        <div className="col-md-3 mb-3">
          <label style={{ fontWeight: "bold" }} className="mb-1">
            Total Tax Fare
          </label>

          <RenderTextInput
            type="number"
            name={`price.TAF`}
            // display="Affiliate Service"
            placeholder="Tax Fare"
            value={values?.price?.TAF}
            error={errors?.price?.TAF}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched?.price?.TAF}
          />
        </div>
        <div className="col-md-3 mb-3">
          <label style={{ fontWeight: "bold" }} className="mb-1">
            Total Fare
          </label>

          <RenderTextInput
            type="number"
            name={`price.TF`}
            placeholder="Total Fare"
            value={values?.price?.TF}
            error={errors?.price?.TF}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched?.price?.TF}
          />
        </div>

        <div className="col-md-3 mb-3">
          <label style={{ fontWeight: "bold" }} className="mb-1">
            Total Net Fare
          </label>

          <RenderTextInput
            type="number"
            name={`price.NF`}
            placeholder="Total Base Fare"
            value={values?.price?.NF}
            error={errors?.price?.NF}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched?.price?.NF}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label style={{ fontWeight: "bold" }} className="mb-1">
            Admin Markup
          </label>

          <RenderTextInput
            type="number"
            name={`adminMarkup`}
            placeholder="Admin Markup"
            value={values?.adminMarkup}
            error={errors?.adminMarkup}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched?.adminMarkup}
          />
        </div>{" "}
        <div className="col-md-6 mb-3">
          <label style={{ fontWeight: "bold" }} className="mb-1">
            User Markup
          </label>

          <RenderTextInput
            type="number"
            name={`userMarkup`}
            placeholder="Admin Markup"
            value={values?.userMarkup}
            error={errors?.userMarkup}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched?.userMarkup}
          />
        </div>
      </div>
    </div>
  );
}
